<!-- Revised on 2024/11/25 by mnavarro -->
<template>
  <div class="toast fade p-2 mt-2 position" :class="{'show': isVisible, ...getColor(color)}">
    <div class="toast-header bg-transparent border-0">
      <i class="me-2 fa-2x icon-header" :class="getIcon(icon)" />
      <span class="me-auto font-weight-bold" :class="getTextColor(color)">
        {{ title }}
      </span>
      <small :class="getTextColor(color)">{{ date }}</small>
      <i class="fas fa-times text-md ms-3 cursor-pointer" :class="getTextColor(color)" @click="closeNotification()" />
    </div>
    <hr class="horizontal dark m-0" :class="getHrColor(color)" />
    <div class="toast-body" :class="getTextColor(color)">
      {{ message }}
    </div>
  </div>
</template>

<script>

  export default {
    name: "Notification",
    props: {
      show: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      date: {
        type: String,
        default: ""
      },
      message: {
        type: String,
        default: ""
      },
      icon: {
        type: [String, Object],
        component: {
          type: String
        },
        color: {
          type: String
        },
        default: () => ({
          color: "success"
        }),
      },
      color: {
        type: String,
        default: "success"
      },
      closeHandler: {
        type: Function,
        default: null
      },
    },
    emits: ['close-handler'],
    data() {
      return {
        isVisible: this.show
      };
    },
    watch: {
      show(newValue) {
        this.isVisible = newValue;
      }
    },
    methods: {
      getColor: (color) => {
        if (color === "white") {
          return { "bg-white": true };
        } else {
          let key = `bg-${color}`;
          return {[key]: true };
        }
      },
      getIcon(icon) {
        if (icon && typeof icon === "string") {
          return icon;
        } else if (icon && typeof icon === "object") {
          return `${icon.component} text-${icon.color}`;
        } else {
          return null;
        }
      },
      closeNotification() {
        this.isVisible = false;
        this.$emit("close-handler")
      },
      close() {
        this.isVisible = false;
      },
      getTextColor: (color) => (color === "white" ? "text-dark" : "text-white"),
      getHrColor: (color) => (color === "white" ? "dark" : "light")
    }
  };

</script>